import { MakeLogicType, afterMount, kea, path } from 'kea'
import { loaders } from 'kea-loaders'

import api from 'lib/api'

import { SourceConfig } from '~/queries/schema/schema-general'

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface availableSourcesLogicValues {
    availableSources: Record<string, SourceConfig> | null
    availableSourcesLoading: boolean
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface availableSourcesLogicActions {
    load: () => any
    loadFailure: (
        error: string,
        errorObject?: any
    ) => {
        error: string
        errorObject?: any
    }
    loadSuccess: (
        availableSources: Record<string, SourceConfig> | null,
        payload?: any
    ) => {
        availableSources: Record<string, SourceConfig> | null
        payload?: any
    }
}

export type availableSourcesLogicType = MakeLogicType<availableSourcesLogicValues, availableSourcesLogicActions>

export const availableSourcesLogic = kea<availableSourcesLogicType>([
    path(['products', 'dataWarehouse', 'availableSourcesLogic']),
    loaders({
        availableSources: [
            null as Record<string, SourceConfig> | null,
            {
                load: async () => {
                    try {
                        return await api.externalDataSources.wizard()
                    } catch (e: any) {
                        if (e.status === 403) {
                            return null
                        }
                        throw e
                    }
                },
            },
        ],
    }),
    afterMount(({ actions }) => {
        actions.load()
    }),
])
